import styled from '@emotion/styled';

import { Notify, NotifyIcon } from '@common/components';

import { GeneralExtraInfo } from '../../components/GeneralExtraInfo';
import { PdpShippingFeeType } from '../../graphql/select-option_types.2';
import { useOptions } from '../../queries/useOptions';

export const ShippingDetailContainer = () => {
  const {
    options: {
      catalog_product: { estimated_shipping_date, shipping_fee, shipping_company },
    },
  } = useOptions();
  const estimates = estimated_shipping_date?.estimate_list ?? null;

  if (!estimates) {
    return <Notify title='배송 정보가 없습니다' icon_type={NotifyIcon.WARNING} />;
  }

  return (
    <Container>
      <GeneralExtraInfo
        shipping_estimate_info={estimates}
        shipping_details={{
          shipping_fee: shipping_fee?.base_fee ?? null,
          shipping_fee_type: shipping_fee?.fee_type ?? PdpShippingFeeType.CHARGED,
          free_shipping_amount: shipping_fee?.minimum_free_shipping_fee ?? null,
          shipping_company: shipping_company?.return_company ?? null,
          additional_shipping_fee_text: shipping_fee?.additional_shipping_fee_text ?? null,
        }}
      />
    </Container>
  );
};

const Container = styled.div`
  margin: -8px 0 0;
`;
